export default __webpack_public_path__ + "static/media/40268.0fe998bb.jpg";